const Footer = () => {
    return (
        <footer aria-labelledby="footer-heading" className="hidden lg:block mt-32 bg-background sm:mt-56">
            <h2 id="footer-heading" className="sr-only">
                Footer
            </h2>
            <p className="mt-8 pt-8 pb-8 text-sm leading-5 text-gray-400 md:order-1 md:mt-0 text-center">
                    &copy; 2025 MarketDataFyi, Inc. All rights reserved.
            </p>
        </footer>
    );
};

export default Footer;